module.exports = __webpack_public_path__ + "static/media/data-analyst-feature-2.681bb288.svg";